'use strict';
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilio-sync/node_modules/core-js/internals/iterators.js
// module id = 850
// module chunks = 25